import type { ConsolidatedLookupData } from '@/services/lookupDataService';

/**
 * Options for {@link recalculate} when running outside the browser (e.g. Node scripts, Jint).
 * Client code can omit these — defaults match prior behavior (browser lookup service).
 */
export interface RecalculateOptions {
    environment?: 'client' | 'server';
    /** Required for accurate school-district surtax when environment is 'server'. */
    consolidatedLookups?: ConsolidatedLookupData | null;
    /**
     * The `Alimony` feature flag. When true, `recalculate()` also brings each alimony scenario's
     * child-support preview up to date with the case's current inputs. Off (the default) leaves
     * `alimonyAnalysis` untouched, so cases and callers that never use the feature pay nothing.
     */
    alimonyEnabled?: boolean;
}

const stack: RecalculateOptions[] = [];

export function runWithCalcRuntimeContext<T>(opts: RecalculateOptions, fn: () => T): T {
    stack.push(opts);
    try {
        return fn();
    } finally {
        stack.pop();
    }
}

/** Current runtime options while inside {@link runWithCalcRuntimeContext} (innermost frame). */
export function getCalcRuntimeContext(): RecalculateOptions | null {
    return stack.length > 0 ? stack[stack.length - 1]! : null;
}
